module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("Yn6Bw"))).then(() => parcelRequire('3a9aZ'));